import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import useTestTag from '../../../common/hooks/use-test-tag';
import OdinIcon, { OdinIconSize } from '../../odin-icon/odin-icon.component';
import type { DropDownResult } from './drop-down-types';

export interface DropDownChipProps {
  value: DropDownResult;
  readOnly?: boolean;
  onRemove: (value: DropDownResult) => void;
  disabled?: boolean;
}

export default function DropDownChip({ value, readOnly, disabled, onRemove }: DropDownChipProps) {
  const chipStyle = clsx(
    'mr-1 mb-1 flex items-center justify-center gap-1 whitespace-nowrap rounded-sm py-0.5 pl-2 text-white',
    { 'bg-primary-2 pr-1': !readOnly && !disabled },
    { 'bg-gray-3 pr-2': readOnly || disabled }
  );

  const tagCreator = useTestTag(value.text || '');
  const { t } = useTranslation();

  return (
    <div className={chipStyle} ref={tagCreator('option')}>
      {value.text}
      {!readOnly && !disabled && (
        <button
          type="button"
          className="rounded-xs focus-visible:outline-2 focus-visible:outline-white"
          onClick={() => onRemove(value)}
          aria-label={`${t('remove')} ${value.text}`}
          ref={tagCreator('selected')}
        >
          <OdinIcon icon="X" size={OdinIconSize.ExtraSmall} />
        </button>
      )}
    </div>
  );
}
